import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  pageTitle: {
    id: 'portal.views.unsubscribeSuccess.title',
    defaultMessage: 'Unsubscribed Successfully',
    description: 'Page title for unsubscribe success',
  },
  heroTitle: {
    id: 'portal.views.unsubscribeSuccess.hero.title',
    defaultMessage: 'Unsubscribed',
    description: 'Hero title for unsubscribe success page',
  },
  mainMessage: {
    id: 'portal.views.unsubscribeSuccess.message',
    defaultMessage: 'You have been successfully unsubscribed from our notifications.',
    description: 'Main success message',
  },
  additionalInfo: {
    id: 'portal.views.unsubscribeSuccess.additionalInfo',
    defaultMessage: 'You will no longer receive notification emails from us. If you change your mind, please contact our support team to have your notifications re-enabled.',
    description: 'Additional information about unsubscription',
  },
  contactSupport: {
    id: 'portal.views.unsubscribeSuccess.contactSupport',
    defaultMessage: 'Contact Support',
    description: 'Link text to contact support',
  },
  returnHome: {
    id: 'portal.views.unsubscribeSuccess.returnHome',
    defaultMessage: 'Return to Home',
    description: 'Link text to return to home page',
  },
  bgAlt: {
    id: 'portal.views.unsubscribeSuccess.bg.alt',
    defaultMessage: 'Unsubscribe success background',
    description: 'Background image alt text',
  },
});

export default messages;
